import { FormBuilder, FormGroup } from '@angular/forms';
import { AddressModel } from './address.model';
import { CodeDescriptionModel } from './code-description.model';
import { BuildingProfileAddress } from './building-profile-address.model';

export class BuildingModel {
    buildingId: string = null;
    hutsBuildingId: number = null;
    hcrBuildingId: number = null;
    addresses: AddressModel [] = [];
    buildingClass: CodeDescriptionModel = null;
    buildingType: CodeDescriptionModel = null;
    buildingDescription: CodeDescriptionModel = null;
    buildingProfileAddresses: BuildingProfileAddress [] = [];
    associationName: string = null;
    stabilizedDate: Date = null;
    numberOfFloors: number = null;

    constructor(model?: Partial<BuildingModel>) {
        if (model && model !== undefined) {
          const def = new BuildingModel();
          Object.keys(def).forEach((key: string) => {
            this[key] = model[key] && model[key] !== undefined ?
              model[key] : def[key];
          });
        }
      }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
          buildingId: [],
          hutsBuildingId: [],
          hcrBuildingId: [],
          addresses: [],
          buildingClass: [],
          buildingType: [],
          buildingProfileAddresses: [],
          buildingDescription: [],
          associationName: [],
          stabilizedDate: [],
          numberOfFloors: []
        });
    }

    static generateForm(fb: FormBuilder, model: BuildingModel): FormGroup {
        const form = BuildingModel.asForm(fb);
        form.setValue(model);
        return form;
    }

    static convertFormToModel(form: FormGroup): BuildingModel {
        return form.value;
    }
}

export class BuildingModels {
  buildingId: string;
  bin: string;
  buildingName: string;
  address: string;
  block: string;
  lot: string;
  borough: string;
  hutsBuildingId: string;
  buildingClassCode: string;
  buildingClassShortName: string;
  buildingTypeCode: string;
  buildingTypeShortName: string;
  buildingDescriptionCode: string;
  buildingDescriptionShortName: string;
  rentStabilizationDate: string;
  noOfFloors: string;
  incomeRestrictedUnits: string;
  marketRateUnits: string;
  stabilizedUnits: string;
  rentControlledUnits: string;
  permExemptUnits: string;

  constructor(model?: Partial<BuildingModels>) {
      if (model && model !== undefined) {
        const def = new BuildingModels();
        Object.keys(def).forEach((key: string) => {
          this[key] = model[key] && model[key] !== undefined ?
            model[key] : def[key];
        });
      }
    }

  static asForm(fb: FormBuilder): FormGroup {
      return fb.group({
        buildingId: '',
        bin: '',
        buildingName: '',
        address: '',
        block: '',
        lot: '',
        borough: '',
        hutsBuildingId: '',
        buildingClassCode: '',
        buildingClassShortName: '',
        buildingTypeCode: '',
        buildingTypeShortName: '',
        buildingDescriptionCode: '',
        buildingDescriptionShortName: '',
        rentStabilizationDate: '',
        noOfFloors: '',
        incomeRestrictedUnits: '',
        marketRateUnits: '',
        stabilizedUnits: '',
        rentControlledUnits: '',
        permExemptUnits: '',
      });
  }

  static generateForm(fb: FormBuilder, model: BuildingModels): FormGroup {
      const form = BuildingModels.asForm(fb);
      form.setValue(model);
      return form;
  }

  static convertFormToModel(form: FormGroup): BuildingModels {
      return form.value;
  }
}

export interface RequestJsonPayload {
  payLoad?: any;
  transactionId?: string;
  sourceRegistrationId?: string;
  buildingId?: string;
  incidentTypeCode?: string;
  transactionType?: string;
}

export interface RequestJsonPayloads {
    transactionId: string;
    sourceRegistrationId: null;
    payLoad: string;
    userName: string;
    incidentType: string;
    incidentTypeCode: string;
    referenceNumber: string;
    jsonDocuments: string;
}


